<template>
    <div class="wrapper">
        <div class="mask"></div>
        <div class="content" ref="content">
            <div class="up-trangle" v-show="showUpTrangle">
                <i></i>
            </div>
            <div class="box" ref="box">
                <div class="info-header">
                    <span class="title">{{title}}</span>
                    <span class="close el-icon-close" @click="closeDialog"></span>
                </div>
                <div class="info-box clearfix" v-if="stuData">
                    <div class="img-box col-1 col">
                        <img v-show="stuData.image" :src="stuData.image" alt=""> 
                    </div>
                    <ul class="col col-2">
                        <li>
                            <div class="label">姓名：</div>
                            <div class="text">{{stuData.name}}</div>
                        </li>
                        <li>
                            <div class="label">学号：</div>
                            <div class="text">{{stuData.studentCode}}</div>
                        </li>
                        <li>
                            <div class="label">性别：</div>
                            <div class="text">{{stuData.gender}}</div>
                        </li>
                        <li>
                            <div class="label">出生日期：</div>
                            <div class="text">{{stuData.bornDate}}</div>
                        </li>
                    </ul>
                    <ul class="col col-3">
                        <li>
                            <div class="label">民族：</div>
                            <div class="text">{{stuData.nation}}</div>
                        </li>
                        <li>
                            <div class="label">班级：</div>
                            <div class="text">{{stuData.cName}}</div>
                        </li>
                        <li>
                            <div class="label">联系电话：</div>
                            <div class="text">{{stuData.phoneNum}}</div>
                        </li>
                        <li>
                            <div class="label">入宿日期：</div>
                            <div class="text">{{stuData.inDate}}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="down-trangel" v-show="showDownTrangle">
                <i></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        eTarget: null,
        title: String,
        data: Object
    },
    data () {
        return {
            showDownTrangle: false,
            stuData: this.data
        }
    },
    watch: {},
    computed: {
        showUpTrangle () {

            if (this.eTarget) {
                let innerHeight = window.innerHeight;
                let obj = this.eTarget.getBoundingClientRect();
                let domHeight = this.$refs.content ?
                    parseFloat(this.$refs.content.getBoundingClientRect().height) :
                    280;
                let bottom = innerHeight - parseFloat(obj.bottom);
                let width = obj.width;
                let left = obj.left;
                let right = parseFloat(window.innerWidth) - parseFloat(obj.right);
                let top;
                // 判断显示框在左在右
                if (right <= 440) {
                    var mr = 280 - 20;
                    this.$nextTick(function () {
                        this.$refs.box.style.right = mr + 'px';

                    })
                } else {
                    this.$nextTick(function () {
                        this.$refs.box.style.right = 'auto';
                    })
                }
                // 判断三角形在上在下。
                let showUpTrangle = bottom > domHeight
                this.showDownTrangle = !showUpTrangle;
                if (showUpTrangle) {
                    top = obj.top + obj.height;
                    this.$nextTick(function () {
                        this.$refs.content.style.left = left + 'px';
                        this.$refs.content.style.top = top + 'px';
                        this.$refs.content.style.bottom = '';
                    })
                } else {
                    bottom = bottom;
                    this.$nextTick(function () {
                        this.$refs.content.style.top = '';
                        this.$refs.content.style.left = left + 'px';
                        this.$refs.content.style.bottom = bottom + 'px';
                    })
                }
                return showUpTrangle;
            }
            return false;
        }

    },
    methods: {
        closeDialog () {
            this.$emit('hideStudentInfoDialog');
            this.stuData = null
        }
    },
    created () {
    },
    mounted () { },
    updated () {
        this.stuData = this.data;

    }
}
</script>
<style lang="scss" scoped>
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: transparent;
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.5;
  }
  .content {
    position: absolute;
    padding: 0;
    min-width: 280px;
    min-height: 268px;
    .box {
      position: absolute;
      width: 440px;
      padding: 10px 10px 20px 20px;
      background-color: #000;
      opacity: 0.7;
      .info-header {
        font-size: 12px;
        color: #fff;
        margin-bottom: 5px;
        .close {
          float: right;
          padding: 0 5px;
          cursor: pointer;
        }
      }
      .info-box {
        display: -webkit-flex; /* Safari */
        display: flex;
        .img-box {
          float: left;
          width: 145px;
          flex-basis: 145px;
          height: 180px;
          padding-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        ul.col {
          flex-grow: 1;
          & > li {
            font-size: 12px;
            height: 50px;
            .label {
              color: #ccc;
              margin-bottom: 8px;
              height: 14px;
              line-height: 14px;
            }
            .text {
              font-size: 13px;
              color: #fff;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .up-trangle {
      background-color: transparent;
      height: 20px;
      i {
        display: inline-block;
        border: 10px solid transparent;
        border-bottom-color: rgba(0, 0, 0, 0.8);
      }
    }
    .down-trangel {
      background-color: transparent;
      height: 20px;
      i {
        display: inline-block;
        border: 10px solid transparent;
        border-top-color: rgba(0, 0, 0, 0.8);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/studentInfo/studentInfo.vue